// Legacy JWT auth keys written by the token-based login flow (see Login.tsx).
// Kept as individual removeItem calls (rather than localStorage.clear()) so
// unrelated data — notably Supabase's own session keys — survives a logout.
const AUTH_STORAGE_KEYS = ['token', 'refreshToken', 'tokenCreatedAt', 'uid', 'language', 'firstName'];

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};
